import React from 'react';
import moment from 'moment';
import { Media } from 'reactstrap';
import ReactEmoji from 'react-emoji';
import classnames from 'classnames';
import customersLogo from 'assets/logo-customers-blue.svg';

const postPicture = picture => picture || customersLogo;
const DropdownItem = ({ item, onSelect }) => (
  <Media className="cg-dropdown__item cg-dropdown__item-row" onClick={onSelect}>
    <Media left>
      <Media
        object
        src={postPicture(item.picture)}
        alt="post image"
        className={classnames('cg-dropdown__item-image', {
          'cg-dropdown__default-image': !item.picture,
        })}
      />
    </Media>
    <Media body>
      <Media heading>
        {moment(item.createdAt).format('MMMM Do, YYYY h:mm a')}
      </Media>
      {ReactEmoji.emojify(item.message)}
    </Media>
  </Media>
);

export default DropdownItem;
